"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSubscriptionExecution = exports.EventSubscription = exports.EventSubscriptionResumeOptions = exports.EventProcessor = exports.EventProcessorType = exports.ResourceType = void 0;
var Converter_1 = require("../../Converter");
var createStringMapSerializers_1 = __importDefault(require("../common/createStringMapSerializers"));
var json2typescript_1 = require("json2typescript");
var ResourceType;
(function (ResourceType) {
    ResourceType["Database"] = "DATABASE";
    ResourceType["AuthEvent"] = "AUTHENTICATION";
    ResourceType["Scheduled"] = "SCHEDULED";
    ResourceType["SyncTranslator"] = "SYNCTRANSLATOR";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var EventProcessorType;
(function (EventProcessorType) {
    EventProcessorType["AWSEventBridge"] = "AWS_EVENTBRIDGE";
    EventProcessorType["Function"] = "FUNCTION";
})(EventProcessorType = exports.EventProcessorType || (exports.EventProcessorType = {}));
var EventProcessor = (function () {
    function EventProcessor(partial) {
        this.config = {};
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('config'),
        __metadata("design:type", Object)
    ], EventProcessor.prototype, "config", void 0);
    EventProcessor = __decorate([
        (0, json2typescript_1.JsonObject)('EventProcessor'),
        __metadata("design:paramtypes", [Object])
    ], EventProcessor);
    return EventProcessor;
}());
exports.EventProcessor = EventProcessor;
var eventProcessorMapSerializers = (0, createStringMapSerializers_1.default)(EventProcessor);
var EventProcessorMapConverter = (function () {
    function EventProcessorMapConverter() {
        this.serialize = eventProcessorMapSerializers.serialize;
        this.deserialize = eventProcessorMapSerializers.deserialize;
    }
    EventProcessorMapConverter = __decorate([
        json2typescript_1.JsonConverter
    ], EventProcessorMapConverter);
    return EventProcessorMapConverter;
}());
var EventSubscriptionResumeOptions = (function () {
    function EventSubscriptionResumeOptions(partial) {
        this.disableToken = false;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('disable_token'),
        __metadata("design:type", Object)
    ], EventSubscriptionResumeOptions.prototype, "disableToken", void 0);
    EventSubscriptionResumeOptions = __decorate([
        (0, json2typescript_1.JsonObject)('EventSubscriptionResumeOptions'),
        __metadata("design:paramtypes", [Object])
    ], EventSubscriptionResumeOptions);
    return EventSubscriptionResumeOptions;
}());
exports.EventSubscriptionResumeOptions = EventSubscriptionResumeOptions;
var EventSubscription = (function () {
    function EventSubscription(partial) {
        this.id = undefined;
        this.name = '';
        this.type = ResourceType.Database;
        this.functionId = undefined;
        this.functionName = undefined;
        this.disabled = false;
        this.config = {};
        this.error = undefined;
        this.errorCoId = undefined;
        this.lastModified = undefined;
        this.eventProcessors = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String, true),
        __metadata("design:type", String)
    ], EventSubscription.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], EventSubscription.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", String)
    ], EventSubscription.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('function_id', String, true),
        __metadata("design:type", String)
    ], EventSubscription.prototype, "functionId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('function_name', String, true),
        __metadata("design:type", String)
    ], EventSubscription.prototype, "functionName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], EventSubscription.prototype, "disabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('config'),
        __metadata("design:type", Object)
    ], EventSubscription.prototype, "config", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('error', String, true),
        __metadata("design:type", String)
    ], EventSubscription.prototype, "error", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('error_co_id', String, true),
        __metadata("design:type", String)
    ], EventSubscription.prototype, "errorCoId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified', Number, true),
        __metadata("design:type", Number)
    ], EventSubscription.prototype, "lastModified", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('event_processors', EventProcessorMapConverter, true),
        __metadata("design:type", Object)
    ], EventSubscription.prototype, "eventProcessors", void 0);
    EventSubscription = __decorate([
        (0, json2typescript_1.JsonObject)('EventSubscription'),
        __metadata("design:paramtypes", [Object])
    ], EventSubscription);
    return EventSubscription;
}());
exports.EventSubscription = EventSubscription;
var EventSubscriptionExecution = (function () {
    function EventSubscriptionExecution(partial) {
        this.data = undefined;
        this.resourceId = '';
        this.completedAt = undefined;
        this.clusterTime = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('data', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], EventSubscriptionExecution.prototype, "data", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('resource_id', String),
        __metadata("design:type", Object)
    ], EventSubscriptionExecution.prototype, "resourceId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('completed_at', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionExecution.prototype, "completedAt", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('cluster_time', Converter_1.DateConverter, true),
        __metadata("design:type", Date)
    ], EventSubscriptionExecution.prototype, "clusterTime", void 0);
    EventSubscriptionExecution = __decorate([
        (0, json2typescript_1.JsonObject)('EventSubscriptionExecution'),
        __metadata("design:paramtypes", [Object])
    ], EventSubscriptionExecution);
    return EventSubscriptionExecution;
}());
exports.EventSubscriptionExecution = EventSubscriptionExecution;
//# sourceMappingURL=EventSubscription.js.map